import { render, staticRenderFns } from "./MockListProjects.vue?vue&type=template&id=0ff964be&scoped=true&"
import script from "./MockListProjects.vue?vue&type=script&lang=js&"
export * from "./MockListProjects.vue?vue&type=script&lang=js&"
import style0 from "./MockListProjects.vue?vue&type=style&index=0&id=0ff964be&prod&scoped=true&lang=css&"
import style1 from "./MockListProjects.vue?vue&type=style&index=1&id=0ff964be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff964be",
  null
  
)

export default component.exports